import { usePermissions } from '../core/PermissionContext';

export function useHasPermission(resource: string, action: string): boolean {
  const engine = usePermissions();
  return engine.hasPermission(resource, action);
}

export function useHasAnyPermission(resource: string, actions: string[]): boolean {
  const engine = usePermissions();
  return engine.hasAnyPermission(resource, actions);
}

export function useHasAllPermissions(resource: string, actions: string[]): boolean {
  const engine = usePermissions();
  return engine.hasAllPermissions(resource, actions);
}
